/**
 * Maps Firebase Auth error codes to friendly, user-facing messages.
 * Falls back to a generic message for unknown codes.
 */
import { FirebaseError } from 'firebase/app';

const MESSAGES: Record<string, string> = {
  'auth/invalid-email': 'That email address looks invalid.',
  'auth/user-disabled': 'This account has been disabled. Contact support.',
  'auth/user-not-found': 'No account found with that email.',
  'auth/wrong-password': 'Incorrect email or password.',
  'auth/invalid-credential': 'Incorrect email or password.',
  'auth/email-already-in-use': 'An account with this email already exists.',
  'auth/weak-password': 'Password should be at least 6 characters.',
  'auth/missing-password': 'Please enter a password.',
  'auth/too-many-requests': 'Too many attempts. Please try again later.',
  'auth/network-request-failed': 'Network error. Check your connection and retry.',
  'auth/requires-recent-login': 'Please re-authenticate to complete this action.',
  'auth/expired-action-code': 'This link has expired. Please request a new one.',
  'auth/invalid-action-code': 'This link is invalid or has already been used.',
  'auth/popup-closed-by-user': 'The sign-in window was closed before finishing.',
  'auth/operation-not-allowed': 'This sign-in method is not enabled.',
};

export function getAuthErrorMessage(error: unknown): string {
  if (error instanceof FirebaseError) {
    return MESSAGES[error.code] ?? error.message.replace('Firebase: ', '');
  }
  if (error instanceof Error) return error.message;
  return 'Something went wrong. Please try again.';
}

/** Returns true when the error means the user must re-authenticate. */
export function needsReauth(error: unknown): boolean {
  return error instanceof FirebaseError && error.code === 'auth/requires-recent-login';
}
